import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=98f1583c&scoped=true&"
import script from "./StudentDetail.vue?vue&type=script&lang=js&"
export * from "./StudentDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&id=98f1583c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f1583c",
  null
  
)

/* custom blocks */
import block0 from "./StudentDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports